<script>
export default {
	name: 'IconSvgVideoLink',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<template>
	<div class="icon-position">
		<svg :width="size" :height="size" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M25.3333 13C25.3333 19.6274 19.9607 25 13.3333 25C6.70591 25 1.33333 19.6274 1.33333 13C1.33333 6.37258 6.70591 1 13.3333 1C19.9607 1 25.3333 6.37258 25.3333 13Z"
				:stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
			<path
				d="M18.5466 12.5629C18.8895 12.7534 18.8895 13.2466 18.5466 13.4371L11.0761 17.5873C10.7429 17.7725 10.3333 17.5315 10.3333 17.1502V8.84976C10.3333 8.46851 10.7429 8.22753 11.0761 8.41268L18.5466 12.5629Z"
				:stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
		</svg>
		<div class="icon-position-videolink">
			<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path fill-rule="evenodd" clip-rule="evenodd"
					  d="M6.99999 13.3333C10.6819 13.3333 13.6667 10.3486 13.6667 6.66667C13.6667 2.98477 10.6819 0 6.99999 0C3.3181 0 0.333328 2.98477 0.333328 6.66667C0.333328 10.3486 3.3181 13.3333 6.99999 13.3333Z"
					  :fill="color" />
				<path
					d="M7.40701 5.53467C7.56052 5.608 7.70438 5.70824 7.83153 5.83538C8.43233 6.43619 8.43233 7.41029 7.83153 8.0111L6.29307 9.54956C5.69226 10.1504 4.71816 10.1504 4.11735 9.54956C3.51655 8.94875 3.51655 7.97465 4.11735 7.37384L4.71803 6.77317M9.28214 6.56049L9.88281 5.95981C10.4836 5.35901 10.4836 4.38491 9.88281 3.7841C9.282 3.18329 8.3079 3.18329 7.7071 3.7841L6.16863 5.32256C5.56783 5.92337 5.56783 6.89747 6.16863 7.49828C6.29578 7.62542 6.43965 7.72566 6.59315 7.79899"
					stroke="white" stroke-width="0.666667" stroke-linecap="round" stroke-linejoin="round" />
			</svg>
		</div>

	</div>
</template>

<style scoped>
.icon-position {
	position: relative;
}

.icon-position-videolink {
	position: absolute;
	right: -4px;
	top: 8px;
}

</style>